/**
 * KAN-951: search over the help sections visible to the role.
 */
import { useMemo, useState } from 'react';
import { searchHelpItems, type HelpItem, type HelpRole } from '@/tutorials/content';

export interface HelpSearch {
  query: string;
  setQuery: (value: string) => void;
  results: HelpItem[];
}

export function useHelpSearch(items: HelpItem[], role: HelpRole): HelpSearch {
  const [query, setQuery] = useState('');
  const results = useMemo(() => searchHelpItems(items, query, role), [items, query, role]);
  return { query, setQuery, results };
}
